/* eslint-disable max-statements */
import axios from 'axios';

import { Controller } from '@context';
import { Feature } from '@features';

export type SaveCustomerEstimateParams = {
	controller: Controller,
	estimate: Blob,
	email: string,
	blueprintId: string,
	designLabel: string,
	getToken: () => Promise<string>,
	mode: string,
	setSuccess?: (success: string) => void,
	setError?: (error: string) => void
};

export const saveCustomerEstimate = async (params: SaveCustomerEstimateParams): Promise<[string | null, string | null]> => {
	const { controller, estimate, getToken, setSuccess, setError, mode, email, blueprintId, designLabel } = params;

	const kitchen = controller?.kitchen ?? null;
	const blueprint = kitchen?.context?.blueprint ?? null;
	const submissionId = blueprint?.submissionId ?? blueprint?.id;

	// const blueprintData = blueprint.serialize();

	// const blueprintData1 = {
	// 	email: customerEmail,
	// 	date: designName,
	// 	layout: kitchenData.layout,
	// 	islands: kitchenData.design.islands.serialize(),
	// 	state: [],
	// 	surround: kitchenData.material.surround.displayName,
	// 	countertop: kitchenData.material.countertop.displayName,
	// 	estimateNumber: '<none>',
	// 	invoiceNumber: kitchenData.quoteId ?? '<none>',
	// 	workordernumber: '<none>',
	// 	fuelchoice: kitchenData.fuelchoice
	// };

	// console.log('saveCustomerEstimate:params', customerEmail, estimate, submissionId, kitchen);

	// Convert blob to base64 to avoid binary corruption during HTTP transfer
	const arrayBuffer = await estimate.arrayBuffer();
	const base64Data = btoa(
		new Uint8Array(arrayBuffer).reduce((data, byte) => data + String.fromCharCode(byte), '')
	);

	try {
		const token = await getToken();
		const apiUrl = import.meta.env.VITE_API_URL;
		const response = await axios.put(`${apiUrl}/customer-estimates/${blueprintId}`, {
			filename: `${blueprintId}.pdf`,
			email,
			designLabel,
			data: base64Data
		}, {
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json'
			}
		});

		console.log('response:save-api', response.status, response.data);
		if (response.status === 200) {
			if (setSuccess) {
				console.log('response:save-api:success', response.data);
				setSuccess(response.data);
			}
			return [response.data ?? null, null];
		}

		throw new Error('Error saving estimate');
	} catch (error) {
		console.log('error', error);
		if (setError) setError('Error saving estimate');
		return [null, 'Error saving estimate'];
	}

	return [null, null];
};
